"use strict";
var $ = require("../internals/export");
var call = require("../internals/function-call");
var iterate = require("../internals/iterate");
var aCallable = require("../internals/a-callable");
var anObject = require("../internals/an-object");
var getIteratorDirect = require("../internals/get-iterator-direct");
var iteratorClose = require("../internals/iterator-close");
var iteratorHelperWithoutClosingOnEarlyError = require("../internals/iterator-helper-without-closing-on-early-error");
var someWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError("some", TypeError);
$({ target: "Iterator", proto: true, real: true, forced: someWithoutClosingOnEarlyError }, {
  some: function some(predicate) {
    anObject(this);
    try {
      aCallable(predicate);
    } catch (error) {
      iteratorClose(this, "throw", error);
    }
    if (someWithoutClosingOnEarlyError) return call(someWithoutClosingOnEarlyError, this, predicate);
    var record = getIteratorDirect(this);
    var counter = 0;
    return iterate(record, function(value, stop) {
      if (predicate(value, counter++)) return stop();
    }, { IS_RECORD: true, INTERRUPTED: true }).stopped;
  }
});
